import React, { useState } from 'react';
import {
  Button,
  Box,
  Tooltip,
  TextField,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddProductMaster = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [productCode, setProductCode] = useState('');
  
const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [mainCategory, setMainCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [brand, setBrand] = useState('');
  const [characteristics, setCharacteristics] = useState('');
  const [productName, setProductName] = useState('');
  const [productNameArabic, setProductNameArabic] = useState('');
  const [unit, setUnit] = useState('');
  const [purchasePrice, setPurchasePrice] = useState('');
  const [sellingPrice, setSellingPrice] = useState('');
  const [openingPrice, setOpeningPrice] = useState('');
  const [barCode, setBarCode] = useState('');
  const [promoDiscount, setPromoDiscount] = useState('');
  const [description, setDescription] = useState('');
  const [taxOption, setTaxOption] = useState('5%');

  // Static data for dropdowns
  const staticMainCategoryData = [
    { mainCategoryId: 1, mainCategory: 'Electronics' },
    { mainCategoryId: 2, mainCategory: 'Clothing' },
    { mainCategoryId: 3, mainCategory: 'Books' },
    { mainCategoryId: 4, mainCategory: 'Home & Kitchen' },
    { mainCategoryId: 5, mainCategory: 'Sports' },
    { mainCategoryId: 6, mainCategory: 'Toys' },
  ];

  const staticSubCategoryData = {
    'Electronics': [
      { subCategoryId: 1, subCategory: 'Smartphones' },
      { subCategoryId: 2, subCategory: 'Laptops' },
    ],
    'Clothing': [
      { subCategoryId: 3, subCategory: 'Men' },
      { subCategoryId: 4, subCategory: 'Women' },
    ],
    'Books': [
      { subCategoryId: 5, subCategory: 'Fiction' },
      { subCategoryId: 6, subCategory: 'Non-Fiction' },
    ],
    'Home & Kitchen': [
      { subCategoryId: 7, subCategory: 'Appliances' },
      { subCategoryId: 8, subCategory: 'Furniture' },
    ],
    'Sports': [
      { subCategoryId: 9, subCategory: 'Outdoor' },
      { subCategoryId: 10, subCategory: 'Indoor' },
    ],
    'Toys': [
      { subCategoryId: 11, subCategory: 'Educational' },
      { subCategoryId: 12, subCategory: 'Action Figures' },
    ],
  };

  const staticBrandData = {
    'Electronics': {
      'Smartphones': ['Samsung', 'Apple', 'Xiaomi'],
      'Laptops': ['Dell', 'HP', 'Lenovo'],
    },
    'Clothing': {
      'Men': ['Nike', 'Adidas', 'Puma'],
      'Women': ['Zara', 'H&M', 'Gucci'],
    },
    'Books': {
      'Fiction': ['Penguin', 'HarperCollins'],
      'Non-Fiction': ['Random House', 'Simon & Schuster'],
    },
    'Home & Kitchen': {
      'Appliances': ['Whirlpool', 'LG', 'Samsung'],
      'Furniture': ['IKEA', 'Ashley', 'Wayfair'],
    },
    'Sports': {
      'Outdoor': ['Nike', 'Adidas', 'Puma'],
      'Indoor': ['Decathlon', 'Nivia', 'Yonex'],
    },
    'Toys': {
      'Educational': ['LEGO', 'Mattel', 'Hasbro'],
      'Action Figures': ['Marvel', 'DC Comics', 'Star Wars'],
    },
  };

  const staticCharacteristicsData = {
    'Electronics': {
      'Smartphones': ['5G', 'AMOLED Display', 'Dual Camera'],
      'Laptops': ['Intel i7', '16GB RAM', 'SSD Storage'],
    },
    'Clothing': {
      'Men': ['Cotton', 'Breathable', 'Waterproof'],
      'Women': ['Silk', 'Lightweight', 'Stretchable'],
    },
    'Books': {
      'Fiction': ['Hardcover', '300 pages', 'Bestseller'],
      'Non-Fiction': ['Paperback', '250 pages', 'Educational'],
    },
    'Home & Kitchen': {
      'Appliances': ['Energy Efficient', 'Stainless Steel', 'Smart'],
      'Furniture': ['Wooden', 'Modern', 'Compact'],
    },
    'Sports': {
      'Outdoor': ['Durable', 'Lightweight', 'Water Resistant'],
      'Indoor': ['Comfortable', 'Breathable', 'Flexible'],
    },
    'Toys': {
      'Educational': ['STEM', 'Interactive', 'Safe'],
      'Action Figures': ['Collectible', 'Articulated', 'Detailed'],
    },
  };

  const staticUnitData = ['Piece', 'Box', 'Kilogram', 'Liter', 'Set'];

  const handleSave = (e) => {
    e.preventDefault();
    if (!productCode || !mainCategory || !subCategory || !brand || !characteristics || !productName || !unit || !purchasePrice || !sellingPrice || !openingPrice || !barCode || !promoDiscount || !description) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
      return;
    }
     setShowSuccessModal(true)
  };

  const handleCancel = () => {
    setProductCode('');
    setMainCategory('');
    setSubCategory('');
    setBrand('');
    setCharacteristics('');
    setProductName('');
    setProductNameArabic('');
    setUnit('');
    setPurchasePrice('');
    setSellingPrice('');
    setOpeningPrice('');
    setBarCode('');
    setPromoDiscount('');
    setDescription('');
    setTaxOption('5%');
  };

  const handleProductDetails = () => {
   setSnackbarMessage('Product detaild button clicked!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
  };

  return (
    <Container maxWidth="lg" sx={{ my: 0 }}>
      <Box
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
           <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                    Product Details
                  </Typography>
                  
                </Box>
        <form onSubmit={handleSave}>
          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Product Code"
              variant="outlined"
              fullWidth
              value={productCode}
              onChange={(e) => setProductCode(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Main Category</InputLabel>
              <Select
                value={mainCategory}
                label="Main Category"
                onChange={(e) => {
                  setMainCategory(e.target.value);
                  setSubCategory('');
                  setBrand('');
                  setCharacteristics('');
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticMainCategoryData.map((category) => (
                  <MenuItem key={category.mainCategoryId} value={category.mainCategory}>
                    {category.mainCategory}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <FormControl fullWidth sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Sub Category</InputLabel>
              <Select
                value={subCategory}
                label="Sub Category"
                onChange={(e) => {
                  setSubCategory(e.target.value);
                  setBrand('');
                  setCharacteristics('');
                }}
                disabled={!mainCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {mainCategory && staticSubCategoryData[mainCategory]?.map((subCat) => (
                  <MenuItem key={subCat.subCategoryId} value={subCat.subCategory}>
                    {subCat.subCategory}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Brand</InputLabel>
              <Select
                value={brand}
                label="Brand"
                onChange={(e) => {
                  setBrand(e.target.value);
                  setCharacteristics('');
                }}
                disabled={!subCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {subCategory && mainCategory && staticBrandData[mainCategory]?.[subCategory]?.map((brandItem) => (
                  <MenuItem key={brandItem} value={brandItem}>
                    {brandItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <FormControl fullWidth sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Characteristics</InputLabel>
              <Select
                value={characteristics}
                label="Characteristics"
                onChange={(e) => setCharacteristics(e.target.value)}
                disabled={!brand}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {brand && subCategory && mainCategory && staticCharacteristicsData[mainCategory]?.[subCategory]?.map((char) => (
                  <MenuItem key={char} value={char}>
                    {char}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Product Name"
              variant="outlined"
              fullWidth
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Product Name (Arabic)"
              variant="outlined"
              fullWidth
              value={productNameArabic}
              onChange={(e) => setProductNameArabic(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth sx={{ '& .MuiInputLabel-root': { color: theme.palette.text.primary }, '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main } }}>
              <InputLabel>Unit</InputLabel>
              <Select
                value={unit}
                label="Unit"
                onChange={(e) => setUnit(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticUnitData.map((unitItem) => (
                  <MenuItem key={unitItem} value={unitItem}>
                    {unitItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Purchase Price"
              variant="outlined"
              fullWidth
              type="number"
              value={purchasePrice}
              onChange={(e) => setPurchasePrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Selling Price"
              variant="outlined"
              fullWidth
              type="number"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Opening Price"
              variant="outlined"
              fullWidth
              type="number"
              value={openingPrice}
              onChange={(e) => setOpeningPrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Bar Code"
              variant="outlined"
              fullWidth
              value={barCode}
              onChange={(e) => setBarCode(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Promo Discount"
              variant="outlined"
              fullWidth
              type="number"
              value={promoDiscount}
              onChange={(e) => setPromoDiscount(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
            
          </Box>

          <FormControl sx={{ mb: 3 }}>
            <FormLabel id="tax-option-label">Tax Option</FormLabel>
            <RadioGroup
              row
              aria-labelledby="tax-option-label"
              name="tax-option"
              value={taxOption}
              onChange={(e) => setTaxOption(e.target.value)}
            >
             <FormControlLabel
  value="5%"
  control={<Radio />}
  label="5%"
  sx={{
    color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    '& .MuiRadio-root': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    },
    '& .Mui-checked': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main),
    },
    '& .MuiTypography-root': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    },
  }}
/>
<FormControlLabel
  value="zero-rated"
  control={<Radio />}
  label="Zero-Rated"
  sx={{
    color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    '& .MuiRadio-root': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    },
    '& .Mui-checked': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main),
    },
    '& .MuiTypography-root': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    },
  }}
/>
<FormControlLabel
  value="exempted"
  control={<Radio />}
  label="Exempted"
  sx={{
    color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    '& .MuiRadio-root': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    },
    '& .Mui-checked': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main),
    },
    '& .MuiTypography-root': {
      color: theme => (theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary),
    },
  }} 
/>
            </RadioGroup>
          </FormControl>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
              }}
              onClick={handleProductDetails}
            >
              Product Details
            </Button>
            <Box>
              <Tooltip
                title={
                  !productCode ? "Enter Product Code" :
                  !mainCategory ? "Select Main Category" :
                  !subCategory ? "Select Sub Category" :
                  !brand ? "Select Brand" :
                  !characteristics ? "Select Characteristics" :
                  !productName ? "Enter Product Name" :
                  !unit ? "Select Unit" :
                  !purchasePrice ? "Enter Purchase Price" :
                  !sellingPrice ? "Enter Selling Price" :
                  !openingPrice ? "Enter Opening Price" :
                  !barCode ? "Enter Bar Code" :
                  !promoDiscount ? "Enter Promo Discount" :
                  !description ? "Enter Description" : ""
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={!productCode || !mainCategory || !subCategory || !brand || !characteristics || !productName || !unit || !purchasePrice || !sellingPrice || !openingPrice || !barCode || !promoDiscount || !description}
                  >
                    SAVE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="outlined"
                color="error"
                onClick={handleCancel}
              >
                RESET
              </Button>
              <Button
                sx={{
                      ml: 2,}}
                variant="outlined"
                color="secondary"
                onClick={() => { navigate(-1) }}
              >
                BACK
              </Button>
            </Box>
          </Box>
        </form>

        <Modal
          open={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
          BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: theme.palette.background.paper,
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
              <Typography variant="h6" sx={{ color: theme.palette.primary.contrastText }}>
                Product Added ✅
              </Typography>
            </Box>
            <Box sx={{ padding: '20px' }}>
              <Typography sx={{ mb: 2 }}>
                Product details have been saved successfully.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowSuccessModal(false);
                    navigate(-1);
                  }}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Box>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default AddProductMaster;